import React, { useEffect, useState } from 'react'
import Button from './Button'
import "./Contact.css"
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    idea: ''
  });
  const [errors, setErrors] = useState({});
   const location = useLocation()
 const [loading, setLoading] = useState(false)
  const validate = () => {
    let newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Invalid phone number (10 digits required)";
    }
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.idea) newErrors.idea = "Please describe your idea";
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const onSubmit = async (event) => {
    console.log(event.target)
    event.preventDefault();
    if (validate()) {
      setLoading(true)
    const formSubmitData = new FormData(event.target);

    // Access Key 
    formSubmitData.append("access_key", "cd01f373-829a-4aa2-ac65-17b36017e631");

    const object = Object.fromEntries(formSubmitData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: json
    }).then((res) => res.json());

    if (res.success) {
      console.log("Success", res);
      toast.success(res.message)
      setLoading(false)
      setFormData({
        name: '',
        phone: '',
        email: '',
        idea: ''
      })
    }else{
      setLoading(false)
      toast.error(res.message)
    }

  }
  };


  
  useEffect(() => {
    if (location.state?.email) {
      setFormData((prev) => ({ ...prev, email: location.state.email }));
    }
  }, [location.state]);


  return (
    <section className='contact-section'>
      <div className='contact'>
     <div className='contact-content'>
        <p className='contact-title-p'>Do You Have a Project to <span>Discuss?</span></p>
        <p className='contact-desc'>It won't take more than 15 minutes to explore</p>
        <div className='contact-btn'>
            <Button btnTitle={`Call us Now`} link={`https://wa.me/919265435410?text=Hi%20there!`}/>
        </div>
     </div>
     <form className="contact-form" onSubmit={onSubmit}>
          <div>
            <input type="text" name="name" placeholder="Name *" value={formData.name} onChange={handleChange} />
            {errors.name && <p className="error">{errors.name}</p>}
          </div>
          <div>
            <input type="tel" name="phone" placeholder="Phone Number *" value={formData.phone} onChange={handleChange} />
            {errors.phone && <p className="error">{errors.phone}</p>}
          </div>
          <div>
            <input type="email" name="email" placeholder="Mail *" value={formData.email} onChange={handleChange} />
            {errors.email && <p className="error">{errors.email}</p>}
          </div>
          <div>
            <textarea name="idea" placeholder="Tell us about your idea *" value={formData.idea} onChange={handleChange}></textarea>
            {errors.idea && <p className="error">{errors.idea}</p>}
          </div>
          <div className='hire-btn'>
            <Button btnTitle={`Inquire now`} handleSubmit={onSubmit} loading={loading}/>
          </div>
        </form>

</div>
    </section>
  )
}

export default Contact